import {ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import {mergeMap, map, catchError} from 'rxjs/operators';
import { IEpicDependency, IAppUser, IAppError } from '../../models';
import { IAppAction } from '../app-action';
import { sessionStateActions, loginError, signUpEmailSuccess, userAlreadyExists } from './session-actions';
import { IAppState } from '../app-state';
import { sendToast, ToastType } from '../../helpers/sendToast';
import { fetchContactFamilyDetails, setContactOnLoginSuccess } from '../contact/contact-actions';
import { fetchCountries } from '../reference-data';
import { fetchHolidays } from '../holiday';

export const signUpEmailEpic = (action$: ActionsObservable<IAppAction>, state$: StateObservable<IAppState>, {api, endPointKeys}:
    IEpicDependency): Observable<IAppAction> => action$.pipe(
        ofType(sessionStateActions.SIGNUP_EMAIL),
        mergeMap(action => {
            var data = JSON.stringify(action.payload);
            return api.post(endPointKeys.api_contact, 'user/signupbyemail', data).pipe(
                map(result => result.data),
                mergeMap((appUser : IAppUser) => {
                    localStorage.removeItem("timedOut");
                    return of(signUpEmailSuccess(appUser),
                            setContactOnLoginSuccess(appUser),
                            fetchCountries(),
                            fetchHolidays(appUser.id),
                            fetchContactFamilyDetails(appUser.id));
                }),
                catchError(error => {
                    const appError : IAppError = { error, message: error.response.data.message};
                    if(appError.message === "This email has already been used to register") {
                        return of(userAlreadyExists(true), loginError(appError));
                    }
                    else {
                        sendToast(appError.message, ToastType.Error);
                        return of(loginError(appError));
                    }
                }))
        })
    )